<template>
  <div>
    <back-btn />
    <v-row justify="center">
      <v-col lg="6">
        <v-card class="card--shadow">
          <v-card-subtitle
            >{{ volunteer.name }} - Training List</v-card-subtitle
          >
          <training-list :trainingData="volunteer.trainings" />
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TrainingList from "@/components/volunteer/training/TrainingList";

import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    TrainingList,
    BackBtn,
  },
  data: () => ({}),
  computed: {
    ...mapState("Volunteer", ["volunteer"]),
    ...mapState("Training", ["trainingData"]),
  },
  created() {
    this.$store.dispatch("Volunteer/getVolunteer", this.$route.params.id);
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
